import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { FundCallWizard } from 'src/Components/FundCalls/FundCallWizard';

const FundCallWizardPage = () => {
  const { t } = useTranslation();
  // Présent sur `fund-calls/:fundCallId/edit` : on reprend ce brouillon.
  const { fundCallId } = useParams<{ fundCallId?: string }>();

  return (
    <AnimatedRoutedDrawer
      title={
        fundCallId
          ? t('fundCalls.wizard.editTitle', 'Modifier le brouillon')
          : t('fundCalls.wizard.title', 'Nouvel appel de fonds')
      }
    >
      {() => <FundCallWizard fundCallId={fundCallId} />}
    </AnimatedRoutedDrawer>
  );
};

export default FundCallWizardPage;
